export enum FileType {
  Unknown = 0,
  Image,
  PDF,
  Video,
}
